import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är skillnaden mellan erinran och varning?";
const SHORT_ANSWER = "Erinran är en mildare påföljd för mindre överträdelser; varning är en allvarligare påföljd som signalerar att fortsatta brister kan leda till återkallelse.";

export const Route = createFileRoute("/fraga/vad-skiljer-erinran-fran-varning")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är skillnaden mellan erinran och varning" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Båda regleras i 9 kap. 17 § alkohollagen. Vid varning står du nästan alltid 'sista chansen' – nästa avvikelse leder ofta till återkallelse. Sanktionsavgift kan kombineras med varning."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Kap. 8 – tillsyn och påföljder" }}
      related={[{"to": "/fraga/vad-ar-kunskapsprovet", "label": "Vad är kunskapsprovet i alkohollagen?"}, {"to": "/fraga/hur-manga-fragor-har-provet", "label": "Hur många frågor har kunskapsprovet?"}, {"to": "/fraga/kan-mitt-tillstand-aterkallas", "label": "Kan mitt serveringstillstånd återkallas?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är skillnaden mellan erinran och varning?" },
      { name: "description", content: "Erinran är en mildare påföljd för mindre överträdelser; varning är en allvarligare påföljd som signalerar att fortsatta brister kan leda till återkallelse." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-skiljer-erinran-fran-varning" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-skiljer-erinran-fran-varning" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-skiljer-erinran-fran-varning",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är skillnaden mellan erinran och varning", url: "https://alkoholprovet.se/fraga/vad-skiljer-erinran-fran-varning" },
      ]),
    ],
  }),
});
